export const BASE_URL = process.env.REACT_APP_URL_API
export const DEV = process.env.NODE_ENV !== "production"
export const CONTACT = process.env.REACT_APP_CONTACT
